import FooterContact from "../components/footerContact"
import FooterItems from "../components/footerItems"
import { apis } from         "../api/apiUrl"    


const Footer = () => {
    return (
        <div className="relative bg-[#191d26] flex flex-col text-white items-center justify-center  w-full ">
            <div className="grid grid-cols-1  lg:grid-cols-[60%_40%] 2xl:gap-4 p-4 md:p-8 w-full place-items-center  2xl:max-w-[80%] ">

                <FooterItems />

                <FooterContact />
            </div>
            <div className="flex items-start justify-center w-full h-16">
                <div className="flex flex-col text-center p-2  md:flex-row items-center  text-xs 2xl:text-sm justify-center py-4 w-full bg-[#1D252D] gap-2 text-gray-400">
                    <span>Copyright &copy; { new Date().getFullYear()} Universiti Tenaga Nasional (199601026142). All rights reserved.</span>
                    <a className="hover:underline underline-offset-1" href={`${apis.domain}media/j5hn13rb/uniten-personal-data-protection-policy.pdf`} target="_blank" rel="noreferrer"  >UNITEN Personal Data Protection Policy</a>
                </div>
            </div>
        </div>
    )
}

export default Footer